export default class AxiosConfig {
  static _token = "";

  static _config = {
    headers: {
      Accept: "application/json, text/javascript, /; q=0.01",
      "Content-Type": "application/json"
    }
  };

  static endpointAddress = process.env.VUE_APP_BASE_API;
  static baseEndpointAddress = process.env.VUE_APP_BASE;
  static storageAddress = process.env.VUE_APP_BASE_STORAGE;
  static xAPIEndpoint = process.env.VUE_APP_XAPI_ENDPOINT;
  static xAPICredentials = process.env.VUE_APP_XAPI_AUTH;

  /**
   *
   * @param token
   */
  static setAuthToken(token) {
    AxiosConfig._token = token;
  }


  /**
   *
   * @param language
   */
  static setLanguage(language) {
    AxiosConfig._config.headers["Accept-Language"] = language;
  }

  /**
   *
   * @returns {string}
   */
  static getAuthToken() {
    return AxiosConfig._token;
  }


  /**
   *
   * @returns {object}
   */
  static getConfig() {
    return AxiosConfig._config;
  }


  /**
   *
   * @returns {object}
   */
  static getAuthConfig() {
    return {
      headers: {
        ...AxiosConfig._config.headers,
        //Authorization: "Bearer " + AxiosConfig._token
      }
    };
  }

  /**
   *
   */
  static getEndpointAddress() {
    return AxiosConfig.endpointAddress;
  }

  /**
   *
   */
  static getBaseEndpointAddress() {
    return AxiosConfig.baseEndpointAddress;
  }

  /**
   *
   * @returns {string}
   */
  static getStorageAddress() {
    return AxiosConfig.storageAddress;
  }

  /**
   *
   * @returns {string}
   */
  static getXAPIEndpoint() {
    return AxiosConfig.xAPIEndpoint;
  }
  /**
   *
   * @returns {string}
   */
  static getXAPICredentials() {
    return AxiosConfig.xAPICredentials; 
  }

  /**
   *
   * @param params
   * @returns {string}
   */
  static objectToURLQuery(params = {}) {
    let arResult = [];
    Object.keys(params).forEach(key => {
      if (params[key] !== null) {
        arResult.push(key + "=" + params[key]);
      }
    });
    return arResult.join("&");
  }
}
